import compareBlocks from './material/section/compareBlocks';

export const generateSocialMediaPayload = <T extends object = object>(
  original: T,
  changes?: T,
) => {
  if (!changes) return undefined;
  const isEqual = compareBlocks(original, changes);
  if (isEqual) return undefined;
  return changes;
};
